/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENV_CONFIG } from 'app/common/config'
import axios from 'axios'
import { getToken } from '../storage/storage-service'

export const handleDownloadFile = async ({
  fileUrl,
  actionSuccess,
}: {
  fileUrl: string
  fileName?: string
  actionSuccess?: () => void
}) => {
  try {
    window.open(fileUrl, '_blank')
    actionSuccess?.()
  } catch (error) {
    console.error('Error downloading file:', error)
  }
}

export interface ResponseUploadFiles {
  url: string
  name: string
}

export const uploadMultipleFiles = async (
  files: File[],
): Promise<ResponseUploadFiles[]> => {
  try {
    const formData = new FormData()
    files.forEach(file => {
      formData.append('files', file)
    })
    const token = getToken()

    const response = await axios.post(
      `${ENV_CONFIG.API_ENDPOINT}upload/multi-files`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          accept: '*/*',
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response?.data?.data ?? []
  } catch (error) {
    console.log({ error })

    return []
  }
}

export const uploadFile = async (
  file: File,
  url: string
): Promise<any> => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    const token = getToken()
    const response = await axios.post(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          accept: '*/*',
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response?.data
  } catch (error) {
    return []
  }
}

export const handleDownloadExcel = async ({
  params,
  urlMethod,
  fileName = 'file'
}: {
  params: any
  urlMethod: string
  fileName?: string
}): Promise<void> => {
  const token = getToken()
  try {
    console.log(urlMethod);
    const response = await axios.get(urlMethod, {
      responseType: 'blob', // Thiết lập kiểu phản hồi là blob
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    })

    // Tạo một URL blob từ dữ liệu file
    const url = window.URL.createObjectURL(new Blob([response.data]))

    // Tạo thẻ <a> để tự động tải file về máy
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.xlsx`) // Tên file Excel sẽ tải về
    document.body.appendChild(link)

    // Kích hoạt sự kiện click để tải file
    link.click()

    // Hủy URL sau khi tải xong
    link.parentNode?.removeChild(link) // Optional chaining để an toàn
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error downloading Excel:', error)
  }
}
